// src/components/Ouvidoria/PublicOuvidoriaPage.js

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PublicOuvidoriaForm from './PublicOuvidoriaForm';
import PublicProtocolSearch from './PublicProtocolSearch';
import '../../styles/Ouvidoria.css'; // Reutiliza os estilos principais
import { FaPenSquare, FaSearch } from 'react-icons/fa';

const PublicOuvidoriaPage = () => {
  // Estado para controlar qual visão está ativa: 'form' ou 'search'
  const [activeView, setActiveView] = useState('form');
  
  // Estado para armazenar o ID da empresa vindo da URL
  const [empresaId, setEmpresaId] = useState(null);
  const [error, setError] = useState('');

  const location = useLocation();

  useEffect(() => {
    // Extrai o 'empresaId' dos parâmetros da URL assim que a página carrega
    const params = new URLSearchParams(location.search);
    const id = params.get('empresaId');
    
    if (id) {
      setEmpresaId(id);
    } else {
      // Se o ID não for encontrado, exibe uma mensagem de erro
      setError('ID da empresa não especificado no link. A página não pode ser carregada.');
    }
  }, [location]);

  // Se houver um erro (link inválido), exibe a mensagem de erro
  if (error) {
    return (
      <div className="ouvidoria-container" style={{ maxWidth: '700px', marginTop: '3rem' }}>
        <p className="error-message">{error}</p>
      </div>
    );
  }

  // Se o empresaId ainda não foi carregado, exibe um estado de carregamento
  if (!empresaId) {
      return <div className="loading-ouvidoria">Carregando...</div>
  }

  return (
    <div className="ouvidoria-container" style={{ maxWidth: '700px', marginTop: '3rem' }}>
      <div className="ouvidoria-header">
        <h1>Canal de Ouvidoria</h1>
        <p className="ouvidoria-subtitle">
          Um espaço seguro e confidencial para registrar suas sugestões, preocupações ou denúncias.
        </p>
      </div>

      {/* Botões para alternar entre as visões de Enviar e Consultar */}
      <div className="ouvidoria-view-toggle">
        <div className="toggle-button-wrapper">
          <button 
            className={`toggle-button ${activeView === 'form' ? 'active' : ''}`} 
            onClick={() => setActiveView('form')}
          >
            <FaPenSquare /> Enviar Manifestação
          </button>
          <button 
            className={`toggle-button ${activeView === 'search' ? 'active' : ''}`} 
            onClick={() => setActiveView('search')}
          >
            <FaSearch /> Consultar Protocolo
          </button>
        </div>
      </div>
      
      {/* Renderização condicional do componente ativo */}
      {activeView === 'form' && <PublicOuvidoriaForm />}
      {activeView === 'search' && <PublicProtocolSearch empresaId={empresaId} />}
    </div>
  );
};

export default PublicOuvidoriaPage;